import React, { useContext, useEffect } from "react";
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select } from "antd";
import moment from "moment";
import TableContext from "../../store/table-context";

const Filters = (props) => {
  const [form] = Form.useForm();
  const { fields, onCodMasterDocSelect } = props;

  const context = useContext(TableContext);

  const onClickCancel = () => {
    context.updateFiltersVisible(false);
  };

  const onClickSearch = (values) => {
    for (const key in values) {
      if (moment.isMoment(values[key])) {
        values[key] = values[key].format("DDMMYYYY");
      }
    }

    if (props.onCodMasterDocSelect) {
      props.onCodMasterDocSelect(values.codMasterDoc);
    }

    context.updateFilters(values);
    context.updateFiltersVisible(false);
  };

  const onClickClear = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (context.filtersVisible) {
      let filters = { ...context.filters };

      for (const key in filters) {
        if (key === "fechaDesde" || key === "fechaHasta") {
          let date = moment(filters[key], 'DD/MM/YYYY');
          if (date.isValid()) {
            filters[key] = date;
          }
        }
      }

      form.setFieldsValue(filters);
    }
  }, [context.filtersVisible]);

  const changeCapture = (value) => {
    onCodMasterDocSelect(value)
    form.resetFields(["descripcionMasterDoc"])
  }

  return (
    <Modal
      open={context.filtersVisible}
      title="Aplicar filtros"
      footer={null}
      onCancel={onClickCancel}
    >
      <Form layout="vertical" form={form} onFinish={onClickSearch}>
        <Row gutter={20}>
          {fields.map((item, index) => (
            <Col span={item.half ? 12 : 24} key={index}>
              {item.type === "input" && !item.hidden && (
                <Form.Item label={item.label} name={item.name} initialValue={item.initialValue}>
                  <Input />
                </Form.Item>
              )}
              {item.type === "date" && !item.hidden && (
                <Form.Item label={item.label} name={item.name} initialValue={item.initialValue}>
                  <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
              )}
              {item.type === "select" && !item.hidden && (
                <Form.Item label={item.label} name={item.name} initialValue={item.initialValue}>
                  <Select onChange={item.changeBool ? changeCapture : null} mode={item.mode} allowClear showSearch optionFilterProp="children" >
                    {item.values.map((option, index) => (
                      <Select.Option disabled={option.disabled} key={index} value={item.name === "codBanco" ? option.text || {} : option.value || {}}>
                        {option.text}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
          ))}
        </Row>

        <div className="actions">
          <Button type="text" onClick={onClickClear}>
            Limpiar
          </Button>
          <Button type="primary" htmlType="submit">
            Buscar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default Filters;
